import { useState, useEffect } from "react";
import slide from "../../../../assets/landing/slide.png"
import "./Carousel.scss"; // Importamos los estilos


const slides = [
  {
    title: "¿Qué es el programa de Convocatorias de Fomento y Estímulos para el Arte y la Cultura?",
    content:
      "El Programa de Convocatorias de Fomento y Estímulos para el Arte y la Cultura busca impulsar el desarrollo de prácticas artísticas, culturales y patrimoniales mediante la participación ciudadana. Su objetivo es facilitar el acceso y disfrute de la cultura, promoviendo iniciativas y garantizando el acceso equitativo y transparente a recursos públicos. El programa se implementa principalmente a través de convocatorias que se desarrollan en diferentes etapas para acercarse a los públicos.",
    image: slide, // Cambia la ruta a tu imagen
  },
  {
    title: "Para acceder a las Convocatorias de Fomento y Estímulos para el Arte y la Cultura, debes:",
    content:
      "Ingresar a la página web: www.medellin.gov.co/estimuloscultura/login. Revisar las convocatorias publicadas, donde encontrarás las fechas de inicio y cierre, el perfil requerido para participar y los lineamientos específicos. Leer detenidamente los requisitos y lineamientos antes de postularte.",
    image: slide, // Cambia la ruta a tu imagen
  },
	{
    title: "Para identificar la convocatoria que mejor se adapta a tus necesidades, sigue estos pasos:",
    content:
      'Ingresa al portal: www.medellin.gov.co/estimuloscultura. Haz clic en "conocer más" en cada convocatoria para explorar las bases de participación. Lee detalladamente los lineamientos, donde se especifica el perfil del participante: Persona natural (individual). Grupo conformado (colectivos sin personería jurídica). Persona jurídica (empresas). Revisa el perfil específico del participante para confirmar si cumples con los requisitos. En la sección "documentos generales", descarga el documento de lineamientos para guiarte en la formulación y presentación de tu propuesta. Asegúrate de cumplir con los documentos administrativos y técnicos en los plazos establecidos. Carga tu propuesta en la plataforma siguiendo los pasos indicados, hasta recibir la confirmación de inscripción exitosa.',
    image: slide, // Cambia la ruta a tu imagen
  },
	{
    title: "Para conocer los resultados de las Convocatorias de Fomento y Estímulos para el Arte y la Cultura, sigue estos pasos:",
    content:
      'Consulta el cronograma de cada convocatoria, donde encontrarás fechas clave, como: Apertura y cierre de la convocatoria. Publicación del informe de propuestas inscritas. Publicación de los informes de evaluación, donde podrás conocer tu puntaje en cada fase. Emisión de la resolución de otorgamiento, que oficializa las propuestas beneficiadas con los estímulos. Todos los documentos estarán disponibles para descargar y consultar en las fechas establecidas dentro del cronograma.',
    image: slide, // Cambia la ruta a tu imagen
  },
	{
    title: "Para saber si debes subsanar documentos en tu propuesta, sigue estos pasos:",
    content:
     'Revisa el cronograma de la convocatoria para identificar las fechas clave relacionadas con la subsanación de documentos. Ingresa regularmente al portal www.medellin.gov.co/estimuloscultura para verificar el estado de tu propuesta. Mantente atento a las notificaciones y solicitudes dentro del portal, donde se indicará si necesitas corregir o completar algún documento. Realiza las correcciones solicitadas dentro de los plazos establecidos para asegurar que tu propuesta siga en proceso. Además, consulta el portal para saber si tu propuesta ha sido seleccionada como beneficiaria de algún estímulo.',
    image: slide, // Cambia la ruta a tu imagen
  },
	{
    title: "¿Es posible participar en múltiples convocatorias durante el año?",
    content:
     'Sí, una persona natural, jurídica o grupo conformado puede participar en varias convocatorias a lo largo del año. No obstante, solo podrá ser beneficiario de hasta cuatro convocatorias de forma simultánea en el mismo año.',
    image: slide, // Cambia la ruta a tu imagen
  },
	{
    title: "Si necesitas asesoría para inscribir tu propuesta en el Programa de Convocatorias de Fomento y Estímulos para el Arte y la Cultura, puedes acudir a las siguientes opciones:",
    content:
     'Líneas de atención telefónica habilitadas para consultas. Asistencia presencial en las socializaciones y conversatorios, cuyas fechas se anuncian en las redes sociales de @cultura.med. Correo electrónico: escribe a convocatorias.cultura@medellin.gov.co para resolver dudas sobre la metodología de presentación, descarga de formatos, revisión de piezas gráficas y entrega de insumos. Estas opciones te permitirán recibir orientación personalizada y resolver cualquier inquietud sobre tu postulación.',
    image: slide, // Cambia la ruta a tu imagen
  },
];

export const Carousel = () => {
  const [index, setIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    setIsAnimating(true);
    const interval = setInterval(() => {
      setIsAnimating(false); // Oculta antes de cambiar
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % slides.length);
        setIsAnimating(true);
      }, 300); // Retardo antes del cambio
    }, 5000);
    return () => clearInterval(interval);
  }, [index]);

  const nextSlide = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIndex((prevIndex) => (prevIndex + 1) % slides.length);
      setIsAnimating(true);
    }, 300);
  };

  const prevSlide = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIndex((prevIndex) => (prevIndex - 1 + slides.length) % slides.length);
      setIsAnimating(true);
    }, 300);
  };

  return (
    <div className={"carousel-container2"}>
      <div className={"carousel-slide2"}>
        {/* Texto con animación */}
        <div className={`${"carousel-text2"} ${isAnimating ? "show2" : ""}`}>
          <h2 style={{backgroundColor: '#d7d4d4', padding: '10px', borderRadius: '10px'}}>{slides[index].title}</h2>
          <p>{slides[index].content}</p>
        </div>

        {/* Imagen con animación */}
        <img
          src={slides[index].image}
          alt="Slide"
          className={`${"carousel-image2"} ${isAnimating ? "show2" : ""}`}
        />
      </div>

      {/* Botones de navegación */}
      <div className={"carousel-buttons2"}>
        <button onClick={prevSlide}>◀</button>
        <button onClick={nextSlide}>▶</button>
      </div>
    </div>
  );
}